$(document).ready(function () {
    'use strict';

    window.onload = function () {
        window.startLoader = function () {
            $('.loading-area').show();
        };

        window.stopLoader = function () {
            $('.loading-area').hide();
        };
        stopLoader();
    };
    
    window.screenLock = function () {
        $('.loading-area').show();
        $('body').css({ 'pointer-events': 'none', 'opacity': '0.6' });
    };

    window.screenUnLock = function () {
        $('body').css({ 'pointer-events': 'auto', 'opacity': '1' });
        $('.loading-area').hide();
    };

    window.togglePopup = function (selector, action, pageTop = false) {
        if (pageTop) {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        }

        const element = document.querySelector(selector);
        if (element) {
            element.classList[action]("hide");
            if (action === "remove") {
                document.body.classList.add("popup-open");
            } else {
                document.body.classList.remove("popup-open");
            }
        }
    }

    window.successMessagePopup = function (message) {
        const messageElement = document.querySelector('.success-msg-text');
        messageElement.innerText = message;

        togglePopup(".success-message", "remove");
        setTimeout(() => togglePopup(".success-message", "add"), 5000);
        document.body.classList.remove("popup-open");
    }

    window.errorMessagePopup = function (message) {
        const messageElement = document.querySelector('.error-msg-text');
        messageElement.innerText = message;

        togglePopup(".error-message", "remove");
        setTimeout(() => togglePopup(".error-message", "add"), 6000);
        document.body.classList.remove("popup-open");
    }

    window.isEmpty = function(value) {
        return value === undefined || value === null || value === '';
    }
});
